import React from "react";
import { Quote } from "lucide-react";
import { Reveal } from "../hooks/useReveal";
import { testimonials } from "../data/siteContent";

const Testimonials = () => {
  return (
    <section className="bg-inkdeep py-24 sm:py-36" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <div className="flex items-center gap-3 text-[11px] sm:text-xs tracking-[0.3em] uppercase font-semibold text-gold">
            <span className="h-px w-10 bg-gold/60" />
            Families We Protect
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-cream tracking-tight leading-[1.06] mt-6">
            Trusted Like <em className="text-gold italic">Family.</em>
          </h2>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-6 mt-14 sm:mt-20">
          {testimonials.map((t, idx) => (
            <Reveal key={t.name} className="h-full" delay={idx * 80}>
              <figure
                className="h-full bg-surface border border-white/8 rounded-2xl p-8 sm:p-10 flex flex-col hover:border-gold/35 transition-colors duration-500"
                data-testid={`testimonial-card-${idx}`}
              >
                <Quote className="w-[26px] h-[26px] text-gold/70" />
                <blockquote className="font-display text-base sm:text-lg text-cream/90 leading-relaxed italic mt-6 flex-1">
                  &ldquo;{t.quote}&rdquo;
                </blockquote>
                <figcaption className="flex items-center gap-4 mt-8 pt-6 border-t border-white/8">
                  <img
                    alt={t.name}
                    loading="lazy"
                    className="w-14 h-14 rounded-full object-cover border-2 border-gold/50"
                    src={t.image}
                  />
                  <div>
                    <p className="text-cream font-semibold text-sm tracking-wide">{t.name}</p>
                    <p className="text-cream/50 text-xs mt-0.5">{t.role}</p>
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
